import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'SO_00001',
                },
            },
            pages: {
                menu: {
                    route: `${code}.pages`,
                    text: `pages.titles`,
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'SO_00010',
                    detail                  : 'SO_00011',
                    add                     : 'SO_00012',
                    edit                    : 'SO_00013',
                    delete                  : 'SO_00014',
                },
                url: {
                    getLists                : `${codeAPI}/gestao/pages/lists`,
                    getList                 : `${codeAPI}/gestao/pages`,
                    getShow                 : `${codeAPI}/gestao/pages/:id`,
                    getCreate               : `${codeAPI}/gestao/pages`,
                    getUpdate               : `${codeAPI}/gestao/pages/:id`,
                    getDelete               : `${codeAPI}/gestao/pages/:id`,
                    quickUpload             : `${codeAPI}/gestao/pages/quickupload`
                },
            },
            pagecategories: {
                menu: {
                    route: `${code}.pagecategories`,
                    text: `pagecategories.titles`,
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'SO_00015',
                    detail                  : 'SO_00016',
                    add                     : 'SO_00017',
                    edit                    : 'SO_00018',
                    delete                  : 'SO_00019',
                },
                url: {
                    getLists                 : `${codeAPI}/gestao/pagecategories/lists`,
                    getList                 : `${codeAPI}/gestao/pagecategories`,
                    getShow                 : `${codeAPI}/gestao/pagecategories/:id`,
                    getCreate               : `${codeAPI}/gestao/pagecategories`,
                    getUpdate               : `${codeAPI}/gestao/pagecategories/:id`,
                    getDelete               : `${codeAPI}/gestao/pagecategories/:id`,
                },
            },
        },
        tools: {

        },
    },
};

export default state;
